import React from "react";
import { HiOutlineInformationCircle } from "react-icons/hi";
import { EXAM_TYPE } from "../../utils";

const CONTEXT_WORD = {
  [EXAM_TYPE.ECHANTILLON]: "urines",
  [EXAM_TYPE.H24]: "urines des 24h",
  [EXAM_TYPE.SEROLOGIE]: "sérologie",
  [EXAM_TYPE.PCR]: "PCR",
};

const firstWord = (value) =>
  (value || "")
    .split(",")
    .map((word) => word.trim())
    .find(Boolean);

const codeValues = (codeObjects) =>
  (codeObjects || [])
    .map((code) => code.value)
    .filter(Boolean)
    .join(" + ");

const TableExamples = ({ codes, exams, examTypePriority }) => {
  const typesWithCodes = (examTypePriority || []).filter((type) => codes[type]?.length > 0);
  if (typesWithCodes.length < 2) return null;

  const fallbackType = typesWithCodes[0];
  const lines = [];

  const commonWord = firstWord(exams[EXAM_TYPE.DEFAULT]);
  if (commonWord) {
    lines.push({ word: commonWord, context: null, result: codeValues(codes[fallbackType]) });
    for (const type of typesWithCodes) {
      if (type === fallbackType || !CONTEXT_WORD[type]) continue;
      lines.push({ word: commonWord, context: CONTEXT_WORD[type], result: codeValues(codes[type]) });
    }
  }

  const urineWord = firstWord(exams[EXAM_TYPE.URINE]);
  const urineFallbackCodes = codes[EXAM_TYPE.ECHANTILLON]?.length > 0 ? codes[EXAM_TYPE.ECHANTILLON] : codes[EXAM_TYPE.H24];
  if (urineWord && urineFallbackCodes?.length > 0) {
    lines.push({ word: urineWord, context: null, result: codeValues(urineFallbackCodes) });
    if (codes[EXAM_TYPE.ECHANTILLON]?.length > 0 && codes[EXAM_TYPE.H24]?.length > 0) {
      lines.push({ word: urineWord, context: CONTEXT_WORD[EXAM_TYPE.H24], result: codeValues(codes[EXAM_TYPE.H24]) });
    }
  }

  const forcedTypes = typesWithCodes.filter((type) => firstWord(exams[type]));
  const forcedType = forcedTypes.find((type) => type !== fallbackType) || forcedTypes[0];
  lines.splice(4);
  if (forcedType) lines.push({ word: firstWord(exams[forcedType]), context: null, result: codeValues(codes[forcedType]), forced: true });

  if (lines.length === 0) return null;

  return (
    <div className="mt-6 flex gap-3 rounded-lg border border-gray-200 bg-gray-50 p-4">
      <HiOutlineInformationCircle className="mt-0.5 h-5 w-5 shrink-0 text-gray-400" />
      <div className="min-w-0 text-xs leading-relaxed text-gray-600">
        <p className="font-medium text-gray-700">Ce que produit cette table</p>
        <ul className="mt-1 space-y-0.5">
          {lines.map((line, index) => (
            <li key={index}>
              « {line.word} »{line.forced ? "" : line.context ? ` sur une ordonnance « ${line.context} »` : " sans précision sur l'ordonnance"} →{" "}
              <span className="font-medium text-gray-800">{line.result}</span>
              {line.forced && ", quel que soit le contexte"}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TableExamples;
